import { TipoDeRecurso } from '@/models/Recurso';
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from 'vue-router';

const rotasDeEtiquetas: RouteConfig[] = [
	{
		path: 'etiquetas',
		name: 'Emissão de Etiquetas',
		components: {
			default: () =>
				import('@/components/produto/TelaDeEtiquetas.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'etiquetas' as TipoDeRecurso,
		},
	},
	{
		path: 'tamanhos-de-etiqueta',
		name: 'Tamanhos de Etiqueta',
		components: {
			default: () =>
				import('@/components/produto/TelaDeCadastroTamanhoDeEtiqueta.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'tamanhos-de-etiqueta' as TipoDeRecurso,
		},
	},
	{
		path: 'modelos-de-etiqueta',
		name: 'Modelos de Etiqueta',
		components: {
			default: () =>
				import('@/components/produto/TelaDeCadastroModeloDeEtiqueta.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'modelos-de-etiqueta' as TipoDeRecurso,
		},
	},
]
export default rotasDeEtiquetas